import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'

import { IWsSectionSettings, IWsSectionSettingsRaw } from './models/iWsSectionSettings'

export interface IFetchSectionSettingsParameters {
  partnerId: string
  fYear: number
  ownerId: string
}

export const fetchSectionSettings = async ({
  partnerId,
  fYear,
  ownerId,
}: IFetchSectionSettingsParameters): Promise<Partial<IWsSectionSettings>> => {
  try {
    const wsClient = WebSocketStore.get('partner360')
    const [token] = getTokens(ownerId)

    const res = await wsClient.call<IWsSectionSettingsRaw[]>({
      service: 'sectionSettings',
      action: 'getSectionSettings',
      payload: {
        partnerId,
        fYear,
      },
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
    })

    if (!res.data.length) {
      return {}
    }

    const [raw] = res.data
    if (raw.SectionSettings === null) {
      return {}
    }

    return JSON.parse(raw.SectionSettings)
  } catch (e: any) {
    return {}
  }
}
